export default {
  serviceCategories(state) {
    return state.serviceCategories
  },
  activeServicesMap(state) {
    return state.activeServicesMap
  },
  activeServices(state) {
    const services = _.values(state.activeServicesMap)
    const serviceIDs = []
    _.forEach(services, service => {
      serviceIDs.push(service.id)
    })
    return serviceIDs
  },
  getSwitchedServiceCategory(state) {
    const id = state.switchedCategoryId
    if (id === null) return {}
    return _.find(state.serviceCategories, category => category.id === id)
  },
}
